/**
 * @generated SignedSource<<38c771d4cd132d84ecd7ff46845b30b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "VibeFollowers",
    "kind": "LinkedField",
    "name": "followUser",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "follower",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followingCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "following",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followersCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followingUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postMenuFollowUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postMenuFollowUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "91b664bc895416c9c85dfa6f59e31cbb",
    "id": null,
    "metadata": {},
    "name": "postMenuFollowUserMutation",
    "operationKind": "mutation",
    "text": "mutation postMenuFollowUserMutation(\n  $userId: String!\n) {\n  followUser(userId: $userId) {\n    id\n    follower {\n      id\n      followingCount\n    }\n    following {\n      id\n      followersCount\n      followingUser\n    }\n  }\n}\n"
  }
};
})();

node.hash = "1fc6c5d7abd6d4bdfabe2082b14239b2";

module.exports = node;
